import React, { useState, useEffect } from "react";
import StudentMenu from "./StudentMenu";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { toast, ToastContainer } from "react-toastify";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { NavLink, useNavigate } from "react-router-dom";
import moment from "moment";
import ThemeCard from "../../UiComponents/common/ThemeCard";
import InputField from "../../UiComponents/common/InputField";
import SelectField from "../../UiComponents/common/SelectField";
import Button from "../../UiComponents/common/Button";
import {
  Info,
  User,
  Users,
  CreditCard,
  Calendar,
  MapPin,
  Home,
  Phone,
  Smartphone,
  Mail,
  MessageCircle,
  BookOpen,
  Bus,
  FileText,
  Save,
  Camera,
  Upload,
  Search,
  Map,
  Globe,
  Award,
  IdCard,
  UserCircle,
  Briefcase,
  CheckSquare,
  Copy,
  X,
  Check,
  CheckCheckIcon,
  Lock
} from "lucide-react";
import UploadCropper from "../../UiComponents/common/UploadCropper";
import Empty from "../../UiComponents/common/Empty";
import PageTitle from "../../UiComponents/userpanel/PageTitle";

function AddStudent(props) {
  const navigate = useNavigate();


  useEffect(() => {
    toast.success("Note: If you don't enter a registration number, an automatic registration number will be assigned.")

  }, [])
  // ==================== SINGLE STATE OBJECT WITH ALL FIELDS ====================
  const [studentData, setStudentData] = useState({
    // Access & User Info
    AccessKey: localStorage.getItem("AccessKey") || "",
    UserID: localStorage.getItem("ID") || "",
    MemberType: localStorage.getItem("MemberType") || "",
    Session_ID: parseInt(localStorage.getItem("DefaultSession")) || 0,
    UserGroupID: parseInt(localStorage.getItem("User_Group_ID")) || 0,

    // Basic Information
    Registration_No: "",
    Student_Name: "",
    Father_Name: "",
    Father_CNIC: "",
    Date_Of_Birth: "",
    Bay_Form_No: "",
    Form_No: "",
    Gender: 'Male', // true = male, false = female (default to male)
    FamilyNo: "",
    MotherName: "",
    Mother_CNIC: "",

    // Contact Information
    Temporary_Address: "",
    Permanent_Address: "",
    Tehsil: "",
    District: "",
    Contact_Phone: "",
    Contact_Mobile: "",
    Contact_Email: "",
    Guardian_Name: "",
    WhatsAppNo: "",

    // Parent portal login (passwords stored encrypted on server)
    FatherMobile: "",
    FatherPassword: "",
    MotherMobile: "",
    MotherPassword: "",

    // Academic Information
    Wing_ID: 0,
    Class_ID: 0,
    Section_Id: 0,

    // Transport & Concessions
    Current_Route_Id: "",
    Route_Section_ID: 0,
    Transport_Fee_Type: "pickDrop",
    Concession_Rule_ID: "",
    Concession_Rule_IDs: [],
    Student_Group_Id: 1,
    Concession_Remarks: "",
    Concession_Amount: "",

    // Other Details
    Previous_School_Info: "",
    NOC_Board: "",
    Remarks: "",
    IsRegisterImmediately: false,

    // Vaccination
    Vaccination_Status: "Not Vaccinated",
    Vaccination_Date: "",

    // Photo
    Image: "",
    PreviewImage: "",

    validated: false,
    loading: false,
  });

  // ==================== DROPDOWN DATA STATES ====================
  const [Concessions, setConcessions] = useState([]);
  const [ListOfSessions, setListOfSessions] = useState([]);
  const [ListOfWings, setListOfWings] = useState([]);
  const [ListOfClasses, setListOfClasses] = useState([]);
  const [ListOFSections, setListOfSections] = useState([]);
  const [ListOfRoutes, setListOfRoutes] = useState([]);
  const [ListOfGroups, setListOfGroups] = useState([]);
  const [ListOfRouteSections, setListOfRouteSections] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [loadingSessions, setLoadingSessions] = useState(false);
  const [loadingWings, setLoadingWings] = useState(false);
  const [loadingClasses, setLoadingClasses] = useState(false);
  const [loadingSections, setLoadingSections] = useState(false);
  const [loadingRoutes, setLoadingRoutes] = useState(false);
  const [loadingRouteSections, setLoadingRouteSections] = useState(false);
  const [loadingConcessions, setLoadingConcessions] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(false);

  // ==================== PHOTO MODAL STATES ====================
  const [showModal, setShowModal] = useState(false);
  const [imageSelected, setImageSelected] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);

  const ListOfTransportFeeType = [
    { id: 0, name: "Please Select", value: "y" },
    { id: 1, name: "PickUp", value: "pickUp" },
    { id: 2, name: "DropOff", value: "dropOff" },
    { id: 3, name: "Pick & Drop", value: "pickDrop" },
  ];

  // ==================== INITIAL DATA FETCH ====================
  useEffect(() => {
    document.title = "Add New Student";
    Promise.all([
      fetchConcessions(),
      fetchSessions(),
      fetchWings(),
      fetchRoutes(),
      fetchStudentGroups(),
    ])
      .catch(() => {
        // handled by individual requests
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, []);

  // ==================== FETCH FUNCTIONS ====================
  const fetchConcessions = () => {
    setLoadingConcessions(true);
    const data = {
      AccessKey: studentData.AccessKey,
      UserID: studentData.UserID,
      MemberType: studentData.MemberType,
      SchoolID: 1,
      pageNo: 1,
      pageSize: 1000,
    };

    return axios({
      method: "post",
      url: config.base_url + "Concession/GetConcessionRules",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        setConcessions(response.data.ListofRecords || []);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setLoadingConcessions(false);
      });
  };

  const fetchSessions = () => {
    setLoadingSessions(true);
    const data = {
      AccessKey: studentData.AccessKey,
      UserID: studentData.UserID,
      MemberType: studentData.MemberType,
      SchoolID: 1,
      pageNo: 1,
      pageSize: 1000,
    };

    return axios({
      method: "post",
      url: config.base_url + "AcademicSession/GetAcademicSessions",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        setListOfSessions(response.data.ListofRecords || []);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setLoadingSessions(false);
      });
  };

  const fetchWings = () => {
    setLoadingWings(true);
    const data = {
      AccessKey: studentData.AccessKey,
      UserID: studentData.UserID,
      MemberType: studentData.MemberType,
      SchoolID: 1,
      pageNo: 1,
      pageSize: 1000,
    };

    return axios({
      method: "post",
      url: config.base_url + "Wings/GetSchoolWings",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        setListOfWings(response.data.ListofRecords || []);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setLoadingWings(false);
      });
  };

  useEffect(() => {
    fetchClasses();
  }, [studentData.Wing_ID, studentData.Session_ID]);

  useEffect(() => {
    fetchSections();
  }, [studentData.Class_ID]);

  useEffect(() => {
    fetchRouteSections();
  }, [studentData.Current_Route_Id]);

  const fetchClasses = () => {
    if (studentData.Wing_ID > 0 && studentData.Session_ID > 0) {
      setLoadingClasses(true);
      const data = {
        AccessKey: studentData.AccessKey,
        UserID: studentData.UserID,
        MemberType: studentData.MemberType,
        Wing_Id: studentData.Wing_ID,
        SessionID: studentData.Session_ID,
        pageNo: 1,
        pageSize: 1000,
      };

      return axios({
        method: "post",
        url: config.base_url + "WingClass/GetClassesByWingnSessionID",
        headers: { "Content-Type": "application/json" },
        data: data,
      })
        .then(function (response) {
          const records = response.data.ListofRecords || [];
          setListOfClasses(records);
          if (records.length === 1) {
            setStudentData(prev => ({ ...prev, Class_ID: records[0].Class_Id }));
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          setLoadingClasses(false);
        });
    }
    return Promise.resolve();
  };

  const fetchSections = () => {
    if (studentData.Class_ID > 0) {
      setLoadingSections(true);
      const data = {
        AccessKey: studentData.AccessKey,
        UserID: studentData.UserID,
        MemberType: studentData.MemberType,
        Class_Id: studentData.Class_ID,
        pageNo: 1,
        pageSize: 1000,
      };

      return axios({
        method: "post",
        url: config.base_url + "Sections/GetAllSections",
        headers: { "Content-Type": "application/json" },
        data: data,
      })
        .then(function (response) {
          const records = response.data.ListofRecords || [];
          setListOfSections(records);
          if (records.length === 1) {
            setStudentData(prev => ({ ...prev, Section_Id: records[0].Section_ID }));
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          setLoadingSections(false);
        });
    }
    return Promise.resolve();
  };

  const fetchRoutes = () => {
    setLoadingRoutes(true);
    const data = {
      AccessKey: studentData.AccessKey,
      UserID: studentData.UserID,
      MemberType: studentData.MemberType,
      SchoolID: 1,
      PageNo: 1,
      PageSize: 100,
    };

    return axios({
      method: "post",
      url: config.base_url + "Busroute/GetBusRoutes",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        setListOfRoutes(response.data.ListofRecords || []);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setLoadingRoutes(false);
      });
  };

  const fetchRouteSections = () => {
    if (studentData.Current_Route_Id) {
      setLoadingRouteSections(true);
      const data = {
        AccessKey: studentData.AccessKey,
        UserID: studentData.UserID,
        MemberType: studentData.MemberType,
        PageNo: 1,
        PageSize: 100,
        SchoolID: studentData.Current_Route_Id,
        Root_Code: "",
        Area_Name: "",
        BusNumber: "",
      };

      axios({
        method: "post",
        url: config.base_url + "Routesection/GetRouteSections",
        headers: { "Content-Type": "application/json" },
        data: data,
      })
        .then(function (response) {
          setListOfRouteSections(response.data.ListofRecords || []);
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {
          setLoadingRouteSections(false);
        });
    }
  };

  const fetchStudentGroups = () => {
    setLoadingGroups(true);
    const data = {
      AccessKey: studentData.AccessKey,
      UserID: studentData.UserID,
      MemberType: studentData.MemberType,
      SchoolID: 1,
      pageNo: 1,
      pageSize: 1000,
    };

    return axios({
      method: "post",
      url: config.base_url + "Student/GetStudentGroups",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        setListOfGroups(response.data.ListofRecords || []);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        setLoadingGroups(false);
      });
  };

  // ==================== HANDLER FUNCTIONS ====================
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setStudentData(prev => ({
        ...prev,
        [name]: checked
      }));
    } else if (type === "radio") {
      setStudentData(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      setStudentData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    if (/^[a-zA-Z\s]*$/.test(value) || value === "") {
      setStudentData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleCNICChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/\D/g, "");

    if (numericValue.length <= 13) {
      setStudentData(prev => ({
        ...prev,
        [name]: numericValue
      }));
    }
  };

  const handlePhoneChange = (e) => {
    const { name } = e.target;
    const value = e.target.value.replace(/\D/g, "").slice(0, 12);
    setStudentData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const isValidMobileOrWhatsApp = (value) => /^923\d{9}$/.test(String(value || "").trim());

  const handleGenderChange = (value) => {
    setStudentData(prev => ({
      ...prev,
      Gender: value
    }));
  };

  const handleRegisterImmediatelyChange = () => {
    setStudentData((prev) => {
      const next = !prev.IsRegisterImmediately;
      return {
        ...prev,
        IsRegisterImmediately: next,
        Registration_No: next ? "" : prev.Registration_No,
      };
    });
  };

  const handleSessionChange = (e) => {
    setStudentData(prev => ({
      ...prev,
      Session_ID: parseInt(e.target.value),
      Wing_ID: 0,
      Section_Id: 0,
      Class_ID: 0
    }));
    setListOfClasses([]);
    setListOfSections([]);
  };

  const handleWingChange = (e) => {
    const wingId = parseInt(e.target.value);
    setStudentData(prev => ({
      ...prev,
      Wing_ID: wingId,
      Section_Id: 0,
      Class_ID: 0
    }));
    setListOfClasses([]);
    setListOfSections([]);
  };

  const handleClassChange = (e) => {
    const classId = parseInt(e.target.value, 10) || 0;
    setStudentData(prev => ({
      ...prev,
      Class_ID: classId,
      Section_Id: 0
    }));
    setListOfSections([]);
  };

  const handleSectionChange = (e) => {
    const sectionId = parseInt(e.target.value, 10) || 0;
    setStudentData(prev => ({
      ...prev,
      Section_Id: sectionId
    }));
  };

  const handleTransportChange = (e) => {
    setStudentData(prev => ({
      ...prev,
      Current_Route_Id: e.target.value,
      Route_Section_ID: 0
    }));
  };


  // ==================== PHOTO HANDLERS ====================
  const handleShowModal = () => setShowModal(true);

  const handleCloseModal = () => {
    setShowModal(false);
    setImageSelected(false);
    setIsUpdated(false);
  };

  const handleImageSelect = (val) => {
    if (val?.croppedData) {
      const base64Image = `data:image/png;base64,${val.croppedData}`;

      setStudentData((prev) => ({
        ...prev,
        Image: val.croppedData,
        PreviewImage: base64Image
      }));

      setImageSelected(true);
    }
  };



  const renderButtons = () => {
    if (isUpdated) {
      return (
        <>
          <div className="modal-footer justify-content-center">
            <Button
              children='Close'
              className="button-primary"
              onClick={handleCloseModal}
              Icon={<Check />}
            />
          </div>
        </>
      );
    } else if (imageSelected) {
      return (
        <>
          <div className="button-row fit m-2">
            <Button
              children='Cancel'
              className="button-outline-primary"
              onClick={() => {
                setImageSelected(false);
                setStudentData(prev => ({ ...prev, Image: '' }));
              }}
              Icon={<X />}
            />
            <Button
              children='Save Photo'
              className="button-primary"
              onClick={() => setIsUpdated(true)}
              Icon={<Check />}
            />
          </div>
        </>
      );
    }
    return null;
  };

  // ==================== VALIDATION ====================
  const validateForm = () => {
    if (studentData.Wing_ID <= 0) {
      toast.error("Please Select Wing", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
    if (studentData.Class_ID <= 0) {
      toast.error("Please Select Class", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
    if (studentData.Section_Id <= 0) {
      toast.error("Please Select Section", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }

    // Father CNIC is required and must be exactly 13 digits
    const fatherCnic = String(studentData.Father_CNIC || "").trim();
    if (!fatherCnic) {
      toast.error("Father CNIC is required", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
    if (fatherCnic.length !== 13 || !/^\d{13}$/.test(fatherCnic)) {
      toast.error("Father CNIC must be exactly 13 digits (numbers only)", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }

    // Mother CNIC is optional but if entered must be 13 digits
    if (studentData.Mother_CNIC && studentData.Mother_CNIC.trim() !== "") {
      if (!/^\d{13}$/.test(studentData.Mother_CNIC)) {
        toast.error("Mother CNIC must be exactly 13 digits", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return false;
      }
    }

    const mobileTrimmed = String(studentData.Contact_Mobile || "").trim();
    if (mobileTrimmed && !isValidMobileOrWhatsApp(mobileTrimmed)) {
      toast.error("Mobile number must be 12 digits starting with 923 (e.g. 923001234567)", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
    const whatsAppTrimmed = String(studentData.WhatsAppNo || "").trim();
    if (whatsAppTrimmed && !isValidMobileOrWhatsApp(whatsAppTrimmed)) {
      toast.error("WhatsApp number must be 12 digits starting with 923 (e.g. 923001234567)", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }

    const fatherMobileTrim = String(studentData.FatherMobile || "").trim();
    const motherMobileTrim = String(studentData.MotherMobile || "").trim();
    const fatherPwdTrim = String(studentData.FatherPassword || "").trim();
    const motherPwdTrim = String(studentData.MotherPassword || "").trim();

    if (fatherPwdTrim && !fatherMobileTrim) {
      toast.error("Father mobile is required when father password is set.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
    if (motherPwdTrim && !motherMobileTrim) {
      toast.error("Mother mobile is required when mother password is set.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
    if (fatherMobileTrim && !isValidMobileOrWhatsApp(fatherMobileTrim)) {
      toast.error("Father mobile must be 12 digits starting with 923 (e.g. 923001234567).", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }
    if (motherMobileTrim && !isValidMobileOrWhatsApp(motherMobileTrim)) {
      toast.error("Mother mobile must be 12 digits starting with 923 (e.g. 923001234567).", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return false;
    }

    return true;
  };

  // ==================== FORM SUBMIT HANDLER ====================
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setStudentData(prev => ({ ...prev, validated: true }));
      return;
    }

    if (!validateForm()) {
      return;
    }

    if (studentData.IsRegisterImmediately && !studentData.Class_ID) {
      toast.error("Class is required to assign a registration number.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    // Final guard: ensure Father CNIC is exactly 13 digits before submitting
    const fatherCnic = String(studentData.Father_CNIC || "").trim();
    if (fatherCnic.length !== 13 || !/^\d{13}$/.test(fatherCnic)) {
      toast.error("Father CNIC must be exactly 13 digits", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setStudentData(prev => ({ ...prev, loading: true }));

    // Prepare API payload matching original code structure
    const payload = {
      // Access & User Info
      AccessKey: studentData.AccessKey,
      UserID: studentData.UserID,
      MemberType: studentData.MemberType,

      // Registration & Basic Info
      Registration_No: studentData.IsRegisterImmediately
        ? String(studentData.Registration_No || "").trim()
        : "",
      Student_Name: studentData.Student_Name,
      Father_Name: studentData.Father_Name,
      Father_CNIC: fatherCnic,
      Temporary_Address: studentData.Temporary_Address || "",
      Permanent_Address: studentData.Permanent_Address || "",
      Date_Of_Birth: studentData.Date_Of_Birth,
      Contact_Phone: studentData.Contact_Phone || "",
      Contact_Mobile: String(studentData.Contact_Mobile || "").trim(),
      Contact_Email: studentData.Contact_Email || "",
      Bay_Form_No: studentData.Bay_Form_No || "",
      Class_ID: studentData.Class_ID,
      Previous_School_Info: studentData.Previous_School_Info || "",
      NOC_Board: studentData.NOC_Board || "",
      Remarks: studentData.Remarks || "",
      Form_No: studentData.Form_No || "",

      // Concession & Transport
      Concession_Rule_ID: studentData.Concession_Rule_IDs && studentData.Concession_Rule_IDs.length > 0
        ? studentData.Concession_Rule_IDs[0]
        : studentData.Concession_Rule_ID || "",
      Concession_Rule_IDs: studentData.Concession_Rule_IDs || [],
      Concession_Remarks: studentData.Concession_Remarks || "",
      Concession_Amount: studentData.Concession_Amount || "",
      Current_Route_Id: studentData.Current_Route_Id || "",
      Route_Section_ID: studentData.Route_Section_ID || 0,
      Transport_Fee_Type: studentData.Transport_Fee_Type || "pickDrop",
      Student_Group_Id: studentData.Student_Group_Id || 1,

      // Academic
      Section_Id: studentData.Section_Id || 0,

      // Vaccination
      Vaccination_Status: studentData.Vaccination_Status || "Not Vaccinated",
      Vaccination_Date: studentData.Vaccination_Date || "",

      // Registration Options
      IsRegisterImmediately: studentData.IsRegisterImmediately || false,

      // Personal Info
      Gender: studentData.Gender == 'Male' ? true : false,

      // Photo (saved as student_id.jpg on add; renamed to registration_no.jpg when reg is confirmed on fee deposit)
      Image: studentData.Image || "",

      // Additional Fields from original code
      FamilyNo: studentData.FamilyNo || "",
      MotherName: studentData.MotherName || "",
      Tehsil: studentData.Tehsil || "",
      District: studentData.District || "",
      Guardian_Name: studentData.Guardian_Name || "",
      WhatsAppNo: String(studentData.WhatsAppNo || "").trim(),
      Mother_CNIC: studentData.Mother_CNIC || "",

      FatherMobile: String(studentData.FatherMobile || "").trim(),
      FatherPassword: String(studentData.FatherPassword || "").trim(),
      MotherMobile: String(studentData.MotherMobile || "").trim(),
      MotherPassword: String(studentData.MotherPassword || "").trim()
    };

    try {
      const response = await axios({
        method: "post",
        url: config.base_url + "Student/AddNewStudent",
        headers: { "Content-Type": "application/json" },
        data: payload,
      });

      if (response.data.status_code === 1) {
        toast.success(response.data.status_message, {
          position: toast.POSITION.TOP_RIGHT,
        });

        // Redirect to Generate Challan page
        const now = new Date();
        const currentMonth = now.getMonth() + 1;
        const currentYear = now.getFullYear();
        const studentId = response.data.ID;

        navigate(`/FeeSystem/GenerateChallan?Student_ID=${studentId}&Month=${currentMonth}&Year=${currentYear}`);
      } else {
        toast.error(response.data.status_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      toast.error("Network Error..", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setStudentData(prev => ({ ...prev, loading: false }));
    }
  };

  if (pageLoading) {
    return (
      <>
        <StudentMenu />
        <div
          style={{
            height: "60vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner animation="border" role="status" />
        </div>
      </>
    );
  }

  return (
    <>
      <StudentMenu />
      <ToastContainer />

      {/* Photo Crop Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="md">
        <Modal.Header closeButton>
          <Modal.Title>Upload Profile Photo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isUpdated ? (
            <Empty
              className="primary center"
              Icon={<CheckCheckIcon />}
              label='Photo Updated Successfully'
            />
          ) : (
            <>
              <UploadCropper
                placeholder="Upload Photo"
                onCropInit={handleImageSelect}
                preview=".image-preview"
                cropWidth="100%"
              />
            </>
          )}
        </Modal.Body>
        {renderButtons()}
      </Modal>

      <div className="container body-content">
        <PageTitle
          title='Add Student'
          breadcrumbs={[
            { to: "/Dashboard", label: "Dashboard" },
            { to: "/students/StudentDashboard", label: "Students" },
            { label: "Add Student" }
          ]}
        >
          <Button
            type="link"
            to="/students/ImportStudent"
            className="button-primary"
          >
            <Upload size={16} style={{ marginRight: "8px" }} />
            Import Students
          </Button>
          <Button
            type="link"
            to="/students/SearchStudents"
            className="button-white"
          >
            <Search size={16} style={{ marginRight: "8px" }} />
            Search Students
          </Button>
        </PageTitle>

        {/* Page Content */}
        <div className="page-content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">

                <Form
                  noValidate
                  validated={studentData.validated}
                  onSubmit={handleSubmit}
                >
                  {/* Basic Information */}
                  <ThemeCard
                    Icon={<Info size={20} />}
                    label="Basic Information"
                    detail="Personal details and identification"
                  >
                    <div className="row">
                      {/* Photo Upload - Left Side */}
                      <div className="col-md-3">
                        <div className="photo-upload-section text-center">
                          <div className="photo-preview-wrapper mb-3">
                            <img
                              // className="image-preview"
                              src={studentData.PreviewImage || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBmFKzyL1zd267I4OYwckhj8-VDM1030AU2w&s"}
                              alt="Student"
                            />
                          </div>
                          <div className="photo-upload-actions">
                            <button
                              type="button"
                              onClick={handleShowModal}
                              className="button button-primary button-small"
                              style={{ width: "100%" }}
                            >
                              <Camera size={16} style={{ marginRight: "8px" }} />
                              Choose Photo
                            </button>
                            <p className="photo-hint mt-2">
                              Recommended: Square JPG/PNG, max 2MB
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Form Fields - Right Side */}
                      <div className="col-md-9">
                        <div className="row g-3">
                          <div className="col-md-6">
                            <InputField
                              label="Student Name"
                              name="Student_Name"
                              value={studentData.Student_Name}
                              onChange={handleNameChange}
                              required
                              placeholder="Enter full name"
                              Icon={<User size={18} />}
                            />
                          </div>
                          <div className="col-md-6">
                            <InputField
                              label="Bay Form"
                              type="number"
                              name="Bay_Form_No"
                              value={studentData.Bay_Form_No}
                              onChange={handleChange}
                              placeholder="Bay form no"
                              Icon={<FileText size={18} />}
                            />
                          </div>
                          <div className="col-md-6">
                            <InputField
                              label="Father Name"
                              name="Father_Name"
                              value={studentData.Father_Name}
                              onChange={handleNameChange}
                              required
                              placeholder="Enter father's name"
                              Icon={<Users size={18} />}
                            />
                          </div>
                          <div className="col-md-6">
                            <InputField
                              label="Father CNIC"
                              name="Father_CNIC"
                              value={studentData.Father_CNIC}
                              onChange={handleCNICChange}
                              required
                              placeholder="13 digits e.g. 3520212345678"
                              minLength={13}
                              maxLength={13}
                              error={!!(studentData.Father_CNIC && studentData.Father_CNIC.length !== 13)}
                              Icon={<IdCard size={18} />}
                            />
                            {studentData.Father_CNIC && studentData.Father_CNIC.length !== 13 && (
                              <small className="text-danger d-block mt-1">
                                Father CNIC must be exactly 13 digits (numbers only).
                              </small>
                            )}
                          </div>
                          <div className="col-md-6">
                            <InputField
                              label="Mother Name"
                              name="MotherName"
                              value={studentData.MotherName}
                              onChange={handleNameChange}
                              placeholder="Enter mother's name"
                              Icon={<UserCircle size={18} />}
                            />
                          </div>
                          <div className="col-md-6">
                            <InputField
                              label="Mother CNIC"
                              name="Mother_CNIC"
                              value={studentData.Mother_CNIC}
                              onChange={handleCNICChange}
                              placeholder="0000000000000"
                              maxLength={13}
                              Icon={<IdCard size={18} />}
                            />
                            {studentData.Mother_CNIC && studentData.Mother_CNIC.length < 13 && (
                              <small style={{ color: "#dc3545" }}>CNIC must be 13 digits if entered</small>
                            )}
                          </div>

                          <div className="col-md-4">
                            <InputField
                              label="Form No"
                              type="number"
                              name="Form_No"
                              value={studentData.Form_No}
                              onChange={handleChange}
                              placeholder="Form number"
                              Icon={<Copy size={18} />}
                            />
                          </div>
                          <div className="col-md-4">
                            <InputField
                              label="Family No"
                              type="number"
                              name="FamilyNo"
                              value={studentData.FamilyNo}
                              onChange={handleChange}
                              placeholder="Family number"
                              Icon={<Users size={18} />}
                            />
                          </div>
                          <div className="col-md-4">
                            <InputField
                              label="Date of Birth"
                              type="date"
                              name="Date_Of_Birth"
                              value={studentData.Date_Of_Birth}
                              onChange={handleChange}
                              max={moment().subtract(3, "years").format("YYYY-MM-DD")}
                              Icon={<Calendar size={18} />}
                            />
                          </div>
                          <div className="col-md-4">
                            <SelectField
                              label='Gender'
                              name="gender"
                              value={studentData.Gender}
                              onChange={(e) => handleGenderChange(e.target.value)}
                              options={[
                                { label: 'Male', value: 'male' },
                                { label: 'Female', value: 'female' }
                              ]}
                            />
                          </div>
                          <div className="col-md-4">
                            <SelectField
                              label="Vaccination Status"
                              name="Vaccination_Status"
                              value={studentData.Vaccination_Status}
                              onChange={handleChange}
                              options={[
                                { value: "Not Vaccinated", label: "Not Vaccinated" },
                                { value: "Partially Vaccinated", label: "Partially Vaccinated" },
                                { value: "Fully Vaccinated", label: "Fully Vaccinated" },
                              ]}
                              Icon={<Award size={18} />}
                            />
                          </div>
                          <div className="col-md-4">
                            <InputField
                              label="Vaccination Date"
                              type="date"
                              name="Vaccination_Date"
                              value={studentData.Vaccination_Date}
                              onChange={handleChange}
                              Icon={<Calendar size={18} />}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </ThemeCard>

                  {/* Contact Information */}
                  <ThemeCard
                    Icon={<Phone size={20} />}
                    label="Contact Information"
                    detail="Address and contact details"
                  >
                    <div className="row g-3">
                      <div className="col-md-6">
                        <InputField
                          label="Temporary Address"
                          name="Temporary_Address"
                          value={studentData.Temporary_Address}
                          onChange={handleChange}
                          placeholder="Enter temporary address"
                          Icon={<MapPin size={18} />}
                        />
                      </div>
                      <div className="col-md-6">
                        <InputField
                          label="Permanent Address"
                          name="Permanent_Address"
                          value={studentData.Permanent_Address}
                          onChange={handleChange}
                          placeholder="Enter permanent address"
                          Icon={<Home size={18} />}
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label="Tehsil"
                          name="Tehsil"
                          value={studentData.Tehsil}
                          onChange={handleChange}
                          placeholder="Tehsil"
                          Icon={<Map size={18} />}
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label="District"
                          name="District"
                          value={studentData.District}
                          onChange={handleChange}
                          placeholder="District"
                          Icon={<Globe size={18} />}
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label="Contact Number"
                          type="tel"
                          name="Contact_Phone"
                          value={studentData.Contact_Phone}
                          onChange={handleChange}
                          placeholder="Contact number"
                          Icon={<Phone size={18} />}
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label="Mobile Number"
                          name="Contact_Mobile"
                          value={studentData.Contact_Mobile}
                          onChange={handlePhoneChange}
                          required
                          placeholder="923001234567"
                          minLength={12}
                          maxLength={12}
                          error={!!(studentData.Contact_Mobile && !isValidMobileOrWhatsApp(studentData.Contact_Mobile))}
                          Icon={<Smartphone size={18} />}
                        />
                        {studentData.Contact_Mobile && !isValidMobileOrWhatsApp(studentData.Contact_Mobile) && (
                          <small className="text-danger d-block mt-1">
                            Mobile must be 12 digits starting with 923.
                          </small>
                        )}
                      </div>
                      <div className="col-md-6">
                        <InputField
                          label="Email Address"
                          type="email"
                          name="Contact_Email"
                          value={studentData.Contact_Email}
                          onChange={handleChange}
                          placeholder="student@example.com"
                          Icon={<Mail size={18} />}
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label="Guardian Name"
                          name="Guardian_Name"
                          value={studentData.Guardian_Name}
                          onChange={handleChange}
                          placeholder="Guardian name"
                          Icon={<Users size={18} />}
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label="WhatsApp Number"
                          name="WhatsAppNo"
                          value={studentData.WhatsAppNo}
                          onChange={handlePhoneChange}
                          required
                          placeholder="923001234567"
                          minLength={12}
                          maxLength={12}
                          error={!!(studentData.WhatsAppNo && !isValidMobileOrWhatsApp(studentData.WhatsAppNo))}
                          Icon={<MessageCircle size={18} />}
                        />
                        {studentData.WhatsAppNo && !isValidMobileOrWhatsApp(studentData.WhatsAppNo) && (
                          <small className="text-danger d-block mt-1">
                            WhatsApp must be 12 digits starting with 923.
                          </small>
                        )}
                      </div>
                    </div>
                  </ThemeCard>

                  {/* Parent portal login */}
                  <ThemeCard
                    Icon={<Lock size={20} />}
                    label="Parent Login Control"
                    detail="Father and mother mobile numbers and portal passwords (passwords are encrypted when saved, same as staff users)"
                  >
                    <div className="row g-3">
                      <div className="col-md-6">
                        <InputField
                          label="Father Mobile (login)"
                          name="FatherMobile"
                          value={studentData.FatherMobile}
                          onChange={handlePhoneChange}
                          placeholder="923001234567"
                          minLength={12}
                          maxLength={12}
                          error={!!(studentData.FatherMobile && !isValidMobileOrWhatsApp(studentData.FatherMobile))}
                          Icon={<Smartphone size={18} />}
                        />
                        {studentData.FatherMobile && !isValidMobileOrWhatsApp(studentData.FatherMobile) && (
                          <small className="text-danger d-block mt-1">
                            Must be 12 digits starting with 923.
                          </small>
                        )}
                      </div>
                      <div className="col-md-6">
                        <InputField
                          label="Father Password"
                          type="password"
                          name="FatherPassword"
                          value={studentData.FatherPassword}
                          onChange={handleChange}
                          placeholder="Leave blank if not used"
                          Icon={<Lock size={18} />}
                        />
                      </div>
                      <div className="col-md-6">
                        <InputField
                          label="Mother Mobile (login)"
                          name="MotherMobile"
                          value={studentData.MotherMobile}
                          onChange={handlePhoneChange}
                          placeholder="923001234567"
                          minLength={12}
                          maxLength={12}
                          error={!!(studentData.MotherMobile && !isValidMobileOrWhatsApp(studentData.MotherMobile))}
                          Icon={<Smartphone size={18} />}
                        />
                        {studentData.MotherMobile && !isValidMobileOrWhatsApp(studentData.MotherMobile) && (
                          <small className="text-danger d-block mt-1">
                            Must be 12 digits starting with 923.
                          </small>
                        )}
                      </div>
                      <div className="col-md-6">
                        <InputField
                          label="Mother Password"
                          type="password"
                          name="MotherPassword"
                          value={studentData.MotherPassword}
                          onChange={handleChange}
                          placeholder="Leave blank if not used"
                          Icon={<Lock size={18} />}
                        />
                      </div>
                    </div>
                  </ThemeCard>

                  {/* Academic Information */}
                  <ThemeCard
                    Icon={<BookOpen size={20} />}
                    label="Session / Wing / Class / Section"
                    detail="Select academic session, wing, class and section"
                  >
                    <div className="row g-3 align-items-end">
                      {/* Sessions */}
                      <div className="col-6 col-md-3">
                        <SelectField
                          label="Choose Session"
                          name="Session_ID"
                          value={studentData.Session_ID}
                          loading={loadingSessions}
                          onChange={handleSessionChange}
                          options={ListOfSessions?.map((item) => ({
                            value: item.Session_ID,
                            label: item.Session_Name
                          })) || []}
                          required
                        />
                      </div>
                      {/* Wings */}
                      <div className="col-6 col-md-3">
                        <SelectField
                          key={`wing-${studentData.Session_ID}`}
                          label="Choose Wing"
                          name="Wing_ID"
                          value={studentData.Wing_ID}
                          loading={loadingWings}
                          onChange={handleWingChange}
                          options={[
                            { value: 0, label: "Please Select", disabled: true },
                            ...(ListOfWings?.map((item) => ({
                              value: item.Wing_ID,
                              label: item.Wing_Name
                            })) || [])
                          ]}
                          required
                        />
                      </div>
                      {/* Classes */}
                      <div className="col-6 col-md-3">
                        <SelectField
                          key={`class-${studentData.Session_ID}-${studentData.Wing_ID}`}
                          label="Select Class"
                          name="Class_ID"
                          value={studentData.Class_ID}
                          loading={loadingClasses}
                          onChange={handleClassChange}
                          options={[
                            { value: 0, label: "Please Select", disabled: true },
                            ...(ListOfClasses?.map((item) => ({
                              value: item.Class_Id,
                              label: item.Class_Name
                            })) || [])
                          ]}
                          required
                        />
                      </div>
                      {/* Sections */}
                      <div className="col-6 col-md-3">
                        <SelectField
                          key={`section-${studentData.Class_ID}`}
                          label="Select Section"
                          name="Section_Id"
                          value={studentData.Section_Id}
                          loading={loadingSections}
                          onChange={handleSectionChange}
                          options={[
                            { value: 0, label: "Please Select", disabled: true },
                            ...(ListOFSections?.map((item) => ({
                              value: item.Section_ID,
                              label: item.Section_Name
                            })) || [])
                          ]}
                          required
                        />
                      </div>
                    </div>
                  </ThemeCard>

                  {/* Transport / Concessions / Group */}
                  <ThemeCard
                    Icon={<Bus size={20} />}
                    label="Transport / Concessions / Group"
                    detail="Transport facility, concessions and group details"
                  >
                    <div className="row g-3">
                      {/* Transport Facility */}
                      <div className="col-md-3">
                        <SelectField
                          label="Transport Facility"
                          name="Current_Route_Id"
                          value={studentData.Current_Route_Id}
                          loading={loadingRoutes}
                          onChange={handleTransportChange}
                          options={[
                            { value: "", label: "Please Select" },
                            ...(ListOfRoutes?.map((item) => ({
                              value: item.Root_ID,
                              label: item.Area_Name
                            })) || [])
                          ]}
                        />
                      </div>

                      {/* Route Section */}
                      <div className="col-md-3">

                        <SelectField
                          label="Route Section"
                          name="Route_Section_ID"
                          value={studentData.Route_Section_ID}
                          loading={loadingRouteSections}
                          onChange={handleChange}
                          options={[
                            { value: "", label: "Please Select" },
                            ...(ListOfRouteSections?.map((item) => ({
                              value: item.ID,
                              label: item.Route_Section_Name
                            })) || [])
                          ]}
                          // options={ListOfRouteSections?.map((item) => ({
                          //   value: item.ID,
                          //   label: item.Route_Section_Name
                          // })) || []}
                        />
                      </div>

                      {/* Transport Fee Type */}
                      <div className="col-md-3">
                        <SelectField
                          label="Transport Fee Type"
                          name="Transport_Fee_Type"
                          value={studentData.Transport_Fee_Type}
                          onChange={handleChange}
                          options={ListOfTransportFeeType?.map((item) => ({
                            value: item.value,
                            label: item.name
                          })) || []}
                        />
                      </div>

                      {/* Concessions */}


                      {/* Group */}
                      <div className="col-md-3">
                        <SelectField
                          label="Select Group"
                          name="Student_Group_Id"
                          value={studentData.Student_Group_Id}
                          loading={loadingGroups}
                          onChange={handleChange}
                          options={ListOfGroups?.map((item) => ({
                            value: item.Group_ID,
                            label: item.Group_Name
                          })) || []}
                          // options={[
                          //   { value: "", label: "Please Select" },
                          //   ...(ListOfGroups?.map((item) => ({
                          //     value: item.Group_ID,
                          //     label: item.Group_Name
                          //   })) || [])
                          // ]}
                        />
                        
                      </div>
                      <div className="col-md-12">
                        <ThemeCard
                          label="Select Concessions"
                          detail="Choose applicable concessions for the student"
                        >
                          <div className="row align-items-center g-2">
                            {Concessions && Concessions.length > 0 ? (
                              Concessions.map((item) => (
                                <div className="col-md-4">
                                  <InputField
                                    loading={loadingConcessions}
                                    label={item.Concession_Rule_Name}
                                    key={item.Concession_Rule_ID}
                                    type="checkbox"
                                    id={`concession_${item.Concession_Rule_ID}`}
                                    value={item.Concession_Rule_ID}
                                    checked={studentData.Concession_Rule_IDs.includes(item.Concession_Rule_ID)}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setStudentData(prev => ({
                                          ...prev,
                                          Concession_Rule_IDs: [...prev.Concession_Rule_IDs, item.Concession_Rule_ID],
                                          Concession_Rule_ID: item.Concession_Rule_ID
                                        }));
                                      } else {
                                        setStudentData(prev => {
                                          const updatedIds = prev.Concession_Rule_IDs.filter(id => id !== item.Concession_Rule_ID);
                                          return {
                                            ...prev,
                                            Concession_Rule_IDs: updatedIds,
                                            Concession_Rule_ID: updatedIds.length > 0 ? updatedIds[0] : ""
                                          };
                                        });
                                      }
                                    }}
                                  />
                                </div>
                              ))
                            ) : (
                              <div className="col-md-12 text-center">
                                <small style={{ color: "#666" }}>No concessions available</small>
                              </div>
                            )}
                          </div>
                        </ThemeCard>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-md-6">
                        <InputField
                          label="Concession Remarks"
                          name="Concession_Remarks"
                          value={studentData.Concession_Remarks}
                          onChange={handleChange}
                          placeholder="Enter concession remarks"
                          Icon={<FileText size={18} />}
                        />
                      </div>
                      <div className="col-md-3">
                        <InputField
                          label="Concession Amount"
                          type="number"
                          name="Concession_Amount"
                          value={studentData.Concession_Amount}
                          onChange={handleChange}
                          placeholder="0.00"
                        />
                      </div>
                    </div>
                  </ThemeCard>

                  {/* Other Details */}
                  <ThemeCard
                    Icon={<FileText size={20} />}
                    label="Other Details"
                    detail="Additional information and registration"
                  >
                    <div className="row align-items-end g-3">
                      <div className="col-md-12">
                        <InputField
                          label="Previous School Information"
                          name="Previous_School_Info"
                          value={studentData.Previous_School_Info}
                          onChange={handleChange}
                          placeholder="Enter previous school details"
                          rows={3}
                          Icon={<Briefcase size={18} />}
                        />
                      </div>
                      <div className="col-md-12">
                        <InputField
                          label="NOC Board Information"
                          name="NOC_Board"
                          value={studentData.NOC_Board}
                          onChange={handleChange}
                          placeholder="Enter NOC board information"
                          Icon={<Award size={18} />}
                        />
                      </div>
                      <div className="col-md-12">
                        <InputField
                          label="Remarks"
                          name="Remarks"
                          value={studentData.Remarks}
                          onChange={handleChange}
                          placeholder="Enter any remarks"
                          rows={3}
                          Icon={<Copy size={18} />}
                        />
                      </div>
                      <div className="col-md-4">
                        <InputField
                          type="checkbox"
                          label="Register Immediately"
                          checked={studentData.IsRegisterImmediately}
                          onChange={handleRegisterImmediatelyChange}
                        />
                        <p className="text-muted small mb-0 mt-1">
                          {studentData.IsRegisterImmediately
                            ? "A registration number will be assigned on save (same rules as Admit Student). Use Admit Student later if not checked."
                            : "Student is saved without a registration number; allocate it later from Admit Student."}
                        </p>
                      </div>
                      {studentData.IsRegisterImmediately && (
                        <div className="col-md-4">
                          <InputField
                            label="Registration Number (optional)"
                            name="Registration_No"
                            value={studentData.Registration_No}
                            onChange={handleChange}
                            placeholder="Leave blank to auto-assign"
                            Icon={<CreditCard size={18} />}
                          />
                        </div>
                      )}
                    </div>
                  </ThemeCard>

                  {/* Form Actions */}
                  <div className="row mt-4">
                    <div className="col-md-3 offset-md-9">
                      <Button
                        loading={studentData.loading}
                        type="submit"
                        className="button-primary w-100"
                        Icon={<Save size={18} />}
                      >
                        SAVE STUDENT
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddStudent;